module.exports = __webpack_public_path__ + "media/images/flags/hn-3ced694aa485e3043c59800850c658c8.svg";